import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DanhSachTaiSanApi from "service/danhSachTaiSanApi";
import { getListTaiSan } from "actions/DanhSachTaiSan/";
import StoreApi from "service/storeApi";
import { DanhSachTaiSanCombo } from "constants/danhSachTaiSanConst";
import { useDispatch, useSelector } from "react-redux";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { pushNotification } from "utils/notifications";
import { formatDayMonth } from "utils/formatDate";
export const ChuyenKho = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const initDataAddAndEditnew = {
    taisanId: "",
    ngayChuyenKho: new Date(),
    khoChuyenDenId: "",
    ghichu: "",
  };

  const [dataChuyenKho, setDataChuyenKho] = useState(initDataAddAndEditnew);
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);

  const updateTextValue = (field) => (e) => {
    setDataChuyenKho({
      ...dataChuyenKho,
      [field]: e.target.value,
    });
  };

  const updateDropdown = (field) => (e) => {
    setDataChuyenKho({
      ...dataChuyenKho,
      [field]: e.target.value,
    });
  };

  const onChangeDate = (field) => (evt) => {
    setDataChuyenKho({
      ...dataChuyenKho,
      [field]: evt,
    });
  };
  useEffect(() => {
    StoreApi.combo({}).then((response) => {
      // console.log(response.data);
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      setdataCombo(dataComboReturn);

      DanhSachTaiSanApi.getOneDetailTaiSan(props.TaiSanID.TaiSanID).then(
        (response) => {
          // console.log(response.data.ThongTinTaiSan);
          // alert(response.data.ThongTinTaiSan.Code);
          setDataChuyenKho({
            Code: response.data.ThongTinTaiSan.Code,
            StoreName: response.data.ThongTinTaiSan.StoreName,
            ...dataChuyenKho,
            taisanId: response.data.ThongTinTaiSan.TaiSanId,
            khoChuyenDenId: dataComboReturn[0].value,
          });
        }
      );
    });
    // lồng vào trong StoreApi (kho id) để lấy giá trị lúc đầu của kho
  }, []);
  const moveStore = () => {
    DanhSachTaiSanApi.chuyenKho(
      dataChuyenKho.taisanId,
      formatDayMonth(dataChuyenKho.ngayChuyenKho),
      dataChuyenKho.khoChuyenDenId,
      dataChuyenKho.ghichu
    )
      .then((response) => {
        dispatch(getListTaiSan(dataSearch));
      })
      .then(
        (response) => props.onHide(),
        pushNotification("Chuyển kho thành công", "success", "TOP_CENTER", 2000)
      );
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i class="fas fa-shipping-fast"></i>
          </span>{" "}
          Chuyển kho
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form class="form tat-toan">
          <div class="form-body">
            <div class="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse53"
                class="card-header"
                href="#collapse53"
                aria-expanded="true"
                aria-controls="collapse53"
              >
                <a class="card-title lead info collapsed" href={() => false}>
                  <h3>Chuyển kho</h3>
                </a>
              </div>
              <div
                id="collapse53"
                aria-labelledby="headingCollapse53"
                class="card-collapse collapse show"
                aria-expanded="true"
              >
                <div class="card-content">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Mã tài sản"
                              disabled="disabled"
                              inputProps={{
                                name: "Code",
                                value: dataChuyenKho.Code,
                                onChange: updateTextValue("Code"),
                              }}
                            ></TextInputOnRow>
                          </div>

                          <div class="col-md-3">
                            <div class="form-group">
                              <label class="label-control color7-bold">
                                Ngày chuyển kho
                              </label>
                              <DateTimePicker
                                onChange={onChangeDate("ngayChuyenKho")}
                                value={dataChuyenKho.ngayChuyenKho}
                                name="ngayChuyenKho"
                                // customInputRef={register}
                                customInput={
                                  <input
                                    name="ngayChuyenKho"
                                    // ref={register}
                                  ></input>
                                }
                              ></DateTimePicker>
                            </div>
                          </div>

                          <div class="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Kho hiện tại"
                              disabled="disabled"
                              inputProps={{
                                name: "StoreName",
                                value: dataChuyenKho.StoreName,
                                onChange: updateTextValue("StoreName"),
                              }}
                            ></TextInputOnRow>
                          </div>

                          <div class="col-md-3">
                            <div class="form-group">
                              <label
                                for="projectinput2"
                                className="color7-bold"
                              >
                                Kho chuyển đến
                              </label>
                              <select
                                name="khoChuyenDenId"
                                className="selectBox form-control input-sm"
                                value={dataChuyenKho.khoChuyenDenId}
                                onChange={updateDropdown("khoChuyenDenId")}
                              >
                                {dataCombo &&
                                  dataCombo.map((item, idx) => (
                                    <option
                                      key={"objComboStore1" + idx}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label
                                for="projectinput8"
                                className="color7-bold"
                              >
                                Ghi chú
                              </label>
                              <textarea
                                rows="4"
                                class="form-control input-sm"
                                name="ghichu"
                                style={{ minHeight: "80px" }}
                                onChange={updateTextValue("ghichu")}
                                value={dataChuyenKho.ghichu}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={moveStore}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>{" "}
          &nbsp; Xác nhận&nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
